import { ApiProperty } from '@nestjs/swagger';
import { OffsetPaginationResponseDto } from '@sphere/shared/domain';
import { LightActivityTypeResponseDto } from './light-activity.response';

export class ActivityTypeListResponseDto extends OffsetPaginationResponseDto<LightActivityTypeResponseDto> {
  @ApiProperty({ type: () => [LightActivityTypeResponseDto] })
  declare data: LightActivityTypeResponseDto[];
}
